/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Audit_Filterbyevent3Inputs */

const en_coinvestments_audit_filterbyevent3 = /** @type {(inputs: Coinvestments_Audit_Filterbyevent3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filter by event type`)
};

/**
* | output |
* | --- |
* | "Filter by event type" |
*
* @param {Coinvestments_Audit_Filterbyevent3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_audit_filterbyevent3 = /** @type {((inputs?: Coinvestments_Audit_Filterbyevent3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Audit_Filterbyevent3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_audit_filterbyevent3(inputs)
});
export { coinvestments_audit_filterbyevent3 as "coInvestments_audit_filterByEvent" }